// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as FeltRouteImport } from './routes/felt'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as QTokenRouteImport } from './routes/q.$token'
import { Route as FeltIndexRouteImport } from './routes/felt.index'
import { Route as FeltVeggRouteImport } from './routes/felt.vegg'
import { Route as FeltKursRouteImport } from './routes/felt.kurs'
import { Route as FeltFotoRouteImport } from './routes/felt.foto'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AuthenticatedProjectsRouteImport } from './routes/_authenticated/projects'
import { Route as AuthenticatedPortalRouteImport } from './routes/_authenticated/portal'
import { Route as AuthenticatedMaterialsRouteImport } from './routes/_authenticated/materials'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedCustomersRouteImport } from './routes/_authenticated/customers'
import { Route as AuthenticatedCalculationsRouteImport } from './routes/_authenticated/calculations'
import { Route as AuthenticatedTakstIndexRouteImport } from './routes/_authenticated/takst.index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings.index'
import { Route as AuthenticatedQuotesIndexRouteImport } from './routes/_authenticated/quotes.index'
import { Route as AuthenticatedInvoicesIndexRouteImport } from './routes/_authenticated/invoices.index'
import { Route as AuthenticatedTakstIdRouteImport } from './routes/_authenticated/takst.$id'
import { Route as AuthenticatedReportsMarginRouteImport } from './routes/_authenticated/reports.margin'
import { Route as AuthenticatedQuotesIdRouteImport } from './routes/_authenticated/quotes.$id'
import { Route as AuthenticatedInvoicesSetupRouteImport } from './routes/_authenticated/invoices.setup'
import { Route as AuthenticatedInvoicesArkivRouteImport } from './routes/_authenticated/invoices.arkiv'
import { Route as AuthenticatedInvoicesIdRouteImport } from './routes/_authenticated/invoices.$id'
import { Route as AuthenticatedDokumentasjonAreaRouteImport } from './routes/_authenticated/dokumentasjon.$area'
import { Route as AuthenticatedProjectsIdRouteImport } from './routes/_authenticated/projects.$id'
import { Route as AuthenticatedCalculationsIndexRouteImport } from './routes/_authenticated/calculations.index'
import { Route as AuthenticatedCalculationsVoltageDropRouteImport } from './routes/_authenticated/calculations.voltage-drop'
import { Route as AuthenticatedCalculationsPowerRouteImport } from './routes/_authenticated/calculations.power'
import { Route as AuthenticatedCalculationsOhmsRouteImport } from './routes/_authenticated/calculations.ohms'
import { Route as AuthenticatedCalculationsMotorRouteImport } from './routes/_authenticated/calculations.motor'
import { Route as AuthenticatedCalculationsCurrentRouteImport } from './routes/_authenticated/calculations.current'
import { Route as AuthenticatedCalculationsConversionRouteImport } from './routes/_authenticated/calculations.conversion'
import { Route as AuthenticatedCalculationsCableRouteImport } from './routes/_authenticated/calculations.cable'
import { Route as AuthenticatedCalculationsBreakerRouteImport } from './routes/_authenticated/calculations.breaker'
import { Route as AuthenticatedSettingsImportIndexRouteImport } from './routes/_authenticated/settings.import.index'
import { Route as AuthenticatedSettingsImportEntityRouteImport } from './routes/_authenticated/settings.import.$entity'
import { Route as AuthenticatedQuotesIdPdfRouteImport } from './routes/_authenticated/quotes.$id_.pdf'
import { Route as AuthenticatedInvoicesIdPurringRouteImport } from './routes/_authenticated/invoices.$id_.purring'
import { Route as AuthenticatedInvoicesIdPdfRouteImport } from './routes/_authenticated/invoices.$id_.pdf'
import { Route as AuthenticatedProjectsIdVisitRouteImport } from './routes/_authenticated/projects.$id.visit'
import { Route as AuthenticatedProjectsIdDocumentationRouteImport } from './routes/_authenticated/projects.$id.documentation'
import { Route as AuthenticatedCalculationsVerktoyIdRouteImport } from './routes/_authenticated/calculations.verktoy.$id'
import { Route as AuthenticatedCalculationsCarpenterVindsperreRouteImport } from './routes/_authenticated/calculations.carpenter.vindsperre'
import { Route as AuthenticatedCalculationsCarpenterUndertakRouteImport } from './routes/_authenticated/calculations.carpenter.undertak'
import { Route as AuthenticatedCalculationsCarpenterTerrassebordRouteImport } from './routes/_authenticated/calculations.carpenter.terrassebord'
import { Route as AuthenticatedCalculationsCarpenterTerrasseBjelkelagRouteImport } from './routes/_authenticated/calculations.carpenter.terrasse-bjelkelag'
import { Route as AuthenticatedCalculationsCarpenterTaksperrerRouteImport } from './routes/_authenticated/calculations.carpenter.taksperrer'
import { Route as AuthenticatedCalculationsCarpenterStendereRouteImport } from './routes/_authenticated/calculations.carpenter.stendere'
import { Route as AuthenticatedCalculationsCarpenterRekkverkRouteImport } from './routes/_authenticated/calculations.carpenter.rekkverk'
import { Route as AuthenticatedCalculationsCarpenterLekterRouteImport } from './routes/_authenticated/calculations.carpenter.lekter'
import { Route as AuthenticatedCalculationsCarpenterKledningRouteImport } from './routes/_authenticated/calculations.carpenter.kledning'
import { Route as AuthenticatedCalculationsCarpenterIsolasjonRouteImport } from './routes/_authenticated/calculations.carpenter.isolasjon'
import { Route as AuthenticatedCalculationsCarpenterGrusRouteImport } from './routes/_authenticated/calculations.carpenter.grus'
import { Route as AuthenticatedCalculationsCarpenterGipsRouteImport } from './routes/_authenticated/calculations.carpenter.gips'
import { Route as AuthenticatedCalculationsCarpenterBjelkelagRouteImport } from './routes/_authenticated/calculations.carpenter.bjelkelag'
import { Route as AuthenticatedCalculationsCarpenterBetongRouteImport } from './routes/_authenticated/calculations.carpenter.betong'
import { Route as AuthenticatedProjectsIdDocumentationPdfRouteImport } from './routes/_authenticated/projects.$id_.documentation.pdf'
import { Route as AuthenticatedProjectsIdCalcPdfRouteImport } from './routes/_authenticated/projects.$id_.calc.pdf'

const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const OnboardingRoute = OnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => rootRouteImport
          })
const FeltRoute = FeltRouteImport.update({
            id: '/felt',path: '/felt',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const QTokenRoute = QTokenRouteImport.update({
            id: '/q/$token',path: '/q/$token',getParentRoute: () => rootRouteImport
          })
const FeltIndexRoute = FeltIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => FeltRoute
          })
const FeltVeggRoute = FeltVeggRouteImport.update({
            id: '/vegg',path: '/vegg',getParentRoute: () => FeltRoute
          })
const FeltKursRoute = FeltKursRouteImport.update({
            id: '/kurs',path: '/kurs',getParentRoute: () => FeltRoute
          })
const FeltFotoRoute = FeltFotoRouteImport.update({
            id: '/foto',path: '/foto',getParentRoute: () => FeltRoute
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/callback',path: '/callback',getParentRoute: () => AuthRoute
          })
const AuthenticatedProjectsRoute = AuthenticatedProjectsRouteImport.update({
            id: '/projects',path: '/projects',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPortalRoute = AuthenticatedPortalRouteImport.update({
            id: '/portal',path: '/portal',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMaterialsRoute = AuthenticatedMaterialsRouteImport.update({
            id: '/materials',path: '/materials',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedCustomersRoute = AuthenticatedCustomersRouteImport.update({
            id: '/customers',path: '/customers',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedCalculationsRoute = AuthenticatedCalculationsRouteImport.update({
            id: '/calculations',path: '/calculations',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedTakstIndexRoute = AuthenticatedTakstIndexRouteImport.update({
            id: '/takst/',path: '/takst/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSettingsIndexRoute = AuthenticatedSettingsIndexRouteImport.update({
            id: '/settings/',path: '/settings/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedQuotesIndexRoute = AuthenticatedQuotesIndexRouteImport.update({
            id: '/quotes/',path: '/quotes/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedInvoicesIndexRoute = AuthenticatedInvoicesIndexRouteImport.update({
            id: '/invoices/',path: '/invoices/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedTakstIdRoute = AuthenticatedTakstIdRouteImport.update({
            id: '/takst/$id',path: '/takst/$id',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedReportsMarginRoute = AuthenticatedReportsMarginRouteImport.update({
            id: '/reports/margin',path: '/reports/margin',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedQuotesIdRoute = AuthenticatedQuotesIdRouteImport.update({
            id: '/quotes/$id',path: '/quotes/$id',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedInvoicesSetupRoute = AuthenticatedInvoicesSetupRouteImport.update({
            id: '/invoices/setup',path: '/invoices/setup',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedInvoicesArkivRoute = AuthenticatedInvoicesArkivRouteImport.update({
            id: '/invoices/arkiv',path: '/invoices/arkiv',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedInvoicesIdRoute = AuthenticatedInvoicesIdRouteImport.update({
            id: '/invoices/$id',path: '/invoices/$id',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDokumentasjonAreaRoute = AuthenticatedDokumentasjonAreaRouteImport.update({
            id: '/dokumentasjon/$area',path: '/dokumentasjon/$area',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedProjectsIdRoute = AuthenticatedProjectsIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AuthenticatedProjectsRoute
          })
const AuthenticatedCalculationsIndexRoute = AuthenticatedCalculationsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedCalculationsRoute
          })
const AuthenticatedCalculationsVoltageDropRoute = AuthenticatedCalculationsVoltageDropRouteImport.update({
            id: '/voltage-drop',path: '/voltage-drop',getParentRoute: () => AuthenticatedCalculationsRoute
          })
const AuthenticatedCalculationsPowerRoute = AuthenticatedCalculationsPowerRouteImport.update({
            id: '/power',path: '/power',getParentRoute: () => AuthenticatedCalculationsRoute
          })
const AuthenticatedCalculationsOhmsRoute = AuthenticatedCalculationsOhmsRouteImport.update({
            id: '/ohms',path: '/ohms',getParentRoute: () => AuthenticatedCalculationsRoute
          })
const AuthenticatedCalculationsMotorRoute = AuthenticatedCalculationsMotorRouteImport.update({
            id: '/motor',path: '/motor',getParentRoute: () => AuthenticatedCalculationsRoute
          })
const AuthenticatedCalculationsCurrentRoute = AuthenticatedCalculationsCurrentRouteImport.update({
            id: '/current',path: '/current',getParentRoute: () => AuthenticatedCalculationsRoute
          })
const AuthenticatedCalculationsConversionRoute = AuthenticatedCalculationsConversionRouteImport.update({
            id: '/conversion',path: '/conversion',getParentRoute: () => AuthenticatedCalculationsRoute
          })
const AuthenticatedCalculationsCableRoute = AuthenticatedCalculationsCableRouteImport.update({
            id: '/cable',path: '/cable',getParentRoute: () => AuthenticatedCalculationsRoute
          })
const AuthenticatedCalculationsBreakerRoute = AuthenticatedCalculationsBreakerRouteImport.update({
            id: '/breaker',path: '/breaker',getParentRoute: () => AuthenticatedCalculationsRoute
          })
const AuthenticatedSettingsImportIndexRoute = AuthenticatedSettingsImportIndexRouteImport.update({
            id: '/settings/import/',path: '/settings/import/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSettingsImportEntityRoute = AuthenticatedSettingsImportEntityRouteImport.update({
            id: '/settings/import/$entity',path: '/settings/import/$entity',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedQuotesIdPdfRoute = AuthenticatedQuotesIdPdfRouteImport.update({
            id: '/quotes/$id_/pdf',path: '/quotes/$id/pdf',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedInvoicesIdPurringRoute = AuthenticatedInvoicesIdPurringRouteImport.update({
            id: '/invoices/$id_/purring',path: '/invoices/$id/purring',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedInvoicesIdPdfRoute = AuthenticatedInvoicesIdPdfRouteImport.update({
            id: '/invoices/$id_/pdf',path: '/invoices/$id/pdf',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedProjectsIdVisitRoute = AuthenticatedProjectsIdVisitRouteImport.update({
            id: '/visit',path: '/visit',getParentRoute: () => AuthenticatedProjectsIdRoute
          })
const AuthenticatedProjectsIdDocumentationRoute = AuthenticatedProjectsIdDocumentationRouteImport.update({
            id: '/documentation',path: '/documentation',getParentRoute: () => AuthenticatedProjectsIdRoute
          })
const AuthenticatedCalculationsVerktoyIdRoute = AuthenticatedCalculationsVerktoyIdRouteImport.update({
            id: '/verktoy/$id',path: '/verktoy/$id',getParentRoute: () => AuthenticatedCalculationsRoute
          })
const AuthenticatedCalculationsCarpenterVindsperreRoute = AuthenticatedCalculationsCarpenterVindsperreRouteImport.update({
            id: '/carpenter/vindsperre',path: '/carpenter/vindsperre',getParentRoute: () => AuthenticatedCalculationsRoute
          })
const AuthenticatedCalculationsCarpenterUndertakRoute = AuthenticatedCalculationsCarpenterUndertakRouteImport.update({
            id: '/carpenter/undertak',path: '/carpenter/undertak',getParentRoute: () => AuthenticatedCalculationsRoute
          })
const AuthenticatedCalculationsCarpenterTerrassebordRoute = AuthenticatedCalculationsCarpenterTerrassebordRouteImport.update({
            id: '/carpenter/terrassebord',path: '/carpenter/terrassebord',getParentRoute: () => AuthenticatedCalculationsRoute
          })
const AuthenticatedCalculationsCarpenterTerrasseBjelkelagRoute = AuthenticatedCalculationsCarpenterTerrasseBjelkelagRouteImport.update({
            id: '/carpenter/terrasse-bjelkelag',path: '/carpenter/terrasse-bjelkelag',getParentRoute: () => AuthenticatedCalculationsRoute
          })
const AuthenticatedCalculationsCarpenterTaksperrerRoute = AuthenticatedCalculationsCarpenterTaksperrerRouteImport.update({
            id: '/carpenter/taksperrer',path: '/carpenter/taksperrer',getParentRoute: () => AuthenticatedCalculationsRoute
          })
const AuthenticatedCalculationsCarpenterStendereRoute = AuthenticatedCalculationsCarpenterStendereRouteImport.update({
            id: '/carpenter/stendere',path: '/carpenter/stendere',getParentRoute: () => AuthenticatedCalculationsRoute
          })
const AuthenticatedCalculationsCarpenterRekkverkRoute = AuthenticatedCalculationsCarpenterRekkverkRouteImport.update({
            id: '/carpenter/rekkverk',path: '/carpenter/rekkverk',getParentRoute: () => AuthenticatedCalculationsRoute
          })
const AuthenticatedCalculationsCarpenterLekterRoute = AuthenticatedCalculationsCarpenterLekterRouteImport.update({
            id: '/carpenter/lekter',path: '/carpenter/lekter',getParentRoute: () => AuthenticatedCalculationsRoute
          })
const AuthenticatedCalculationsCarpenterKledningRoute = AuthenticatedCalculationsCarpenterKledningRouteImport.update({
            id: '/carpenter/kledning',path: '/carpenter/kledning',getParentRoute: () => AuthenticatedCalculationsRoute
          })
const AuthenticatedCalculationsCarpenterIsolasjonRoute = AuthenticatedCalculationsCarpenterIsolasjonRouteImport.update({
            id: '/carpenter/isolasjon',path: '/carpenter/isolasjon',getParentRoute: () => AuthenticatedCalculationsRoute
          })
const AuthenticatedCalculationsCarpenterGrusRoute = AuthenticatedCalculationsCarpenterGrusRouteImport.update({
            id: '/carpenter/grus',path: '/carpenter/grus',getParentRoute: () => AuthenticatedCalculationsRoute
          })
const AuthenticatedCalculationsCarpenterGipsRoute = AuthenticatedCalculationsCarpenterGipsRouteImport.update({
            id: '/carpenter/gips',path: '/carpenter/gips',getParentRoute: () => AuthenticatedCalculationsRoute
          })
const AuthenticatedCalculationsCarpenterBjelkelagRoute = AuthenticatedCalculationsCarpenterBjelkelagRouteImport.update({
            id: '/carpenter/bjelkelag',path: '/carpenter/bjelkelag',getParentRoute: () => AuthenticatedCalculationsRoute
          })
const AuthenticatedCalculationsCarpenterBetongRoute = AuthenticatedCalculationsCarpenterBetongRouteImport.update({
            id: '/carpenter/betong',path: '/carpenter/betong',getParentRoute: () => AuthenticatedCalculationsRoute
          })
const AuthenticatedProjectsIdDocumentationPdfRoute = AuthenticatedProjectsIdDocumentationPdfRouteImport.update({
            id: '/$id_/documentation/pdf',path: '/$id/documentation/pdf',getParentRoute: () => AuthenticatedProjectsRoute
          })
const AuthenticatedProjectsIdCalcPdfRoute = AuthenticatedProjectsIdCalcPdfRouteImport.update({
            id: '/$id_/calc/pdf',path: '/$id/calc/pdf',getParentRoute: () => AuthenticatedProjectsRoute
          })





const AuthenticatedCalculationsRouteChildren = {
  AuthenticatedCalculationsBreakerRoute: AuthenticatedCalculationsBreakerRoute,AuthenticatedCalculationsCableRoute: AuthenticatedCalculationsCableRoute,AuthenticatedCalculationsConversionRoute: AuthenticatedCalculationsConversionRoute,AuthenticatedCalculationsCurrentRoute: AuthenticatedCalculationsCurrentRoute,AuthenticatedCalculationsMotorRoute: AuthenticatedCalculationsMotorRoute,AuthenticatedCalculationsOhmsRoute: AuthenticatedCalculationsOhmsRoute,AuthenticatedCalculationsPowerRoute: AuthenticatedCalculationsPowerRoute,AuthenticatedCalculationsVoltageDropRoute: AuthenticatedCalculationsVoltageDropRoute,AuthenticatedCalculationsIndexRoute: AuthenticatedCalculationsIndexRoute,AuthenticatedCalculationsCarpenterBetongRoute: AuthenticatedCalculationsCarpenterBetongRoute,AuthenticatedCalculationsCarpenterBjelkelagRoute: AuthenticatedCalculationsCarpenterBjelkelagRoute,AuthenticatedCalculationsCarpenterGipsRoute: AuthenticatedCalculationsCarpenterGipsRoute,AuthenticatedCalculationsCarpenterGrusRoute: AuthenticatedCalculationsCarpenterGrusRoute,AuthenticatedCalculationsCarpenterIsolasjonRoute: AuthenticatedCalculationsCarpenterIsolasjonRoute,AuthenticatedCalculationsCarpenterKledningRoute: AuthenticatedCalculationsCarpenterKledningRoute,AuthenticatedCalculationsCarpenterLekterRoute: AuthenticatedCalculationsCarpenterLekterRoute,AuthenticatedCalculationsCarpenterRekkverkRoute: AuthenticatedCalculationsCarpenterRekkverkRoute,AuthenticatedCalculationsCarpenterStendereRoute: AuthenticatedCalculationsCarpenterStendereRoute,AuthenticatedCalculationsCarpenterTaksperrerRoute: AuthenticatedCalculationsCarpenterTaksperrerRoute,AuthenticatedCalculationsCarpenterTerrasseBjelkelagRoute: AuthenticatedCalculationsCarpenterTerrasseBjelkelagRoute,AuthenticatedCalculationsCarpenterTerrassebordRoute: AuthenticatedCalculationsCarpenterTerrassebordRoute,AuthenticatedCalculationsCarpenterUndertakRoute: AuthenticatedCalculationsCarpenterUndertakRoute,AuthenticatedCalculationsCarpenterVindsperreRoute: AuthenticatedCalculationsCarpenterVindsperreRoute,AuthenticatedCalculationsVerktoyIdRoute: AuthenticatedCalculationsVerktoyIdRoute
}

const AuthenticatedCalculationsRouteWithChildren = AuthenticatedCalculationsRoute._addFileChildren(AuthenticatedCalculationsRouteChildren)




const AuthenticatedProjectsIdRouteChildren = {
  AuthenticatedProjectsIdDocumentationRoute: AuthenticatedProjectsIdDocumentationRoute,AuthenticatedProjectsIdVisitRoute: AuthenticatedProjectsIdVisitRoute
}

const AuthenticatedProjectsIdRouteWithChildren = AuthenticatedProjectsIdRoute._addFileChildren(AuthenticatedProjectsIdRouteChildren)



const AuthenticatedProjectsRouteChildren = {
  AuthenticatedProjectsIdRoute: AuthenticatedProjectsIdRouteWithChildren,AuthenticatedProjectsIdCalcPdfRoute: AuthenticatedProjectsIdCalcPdfRoute,AuthenticatedProjectsIdDocumentationPdfRoute: AuthenticatedProjectsIdDocumentationPdfRoute
}

const AuthenticatedProjectsRouteWithChildren = AuthenticatedProjectsRoute._addFileChildren(AuthenticatedProjectsRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedCalculationsRoute: AuthenticatedCalculationsRouteWithChildren,AuthenticatedCustomersRoute: AuthenticatedCustomersRoute,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedMaterialsRoute: AuthenticatedMaterialsRoute,AuthenticatedPortalRoute: AuthenticatedPortalRoute,AuthenticatedProjectsRoute: AuthenticatedProjectsRouteWithChildren,AuthenticatedDokumentasjonAreaRoute: AuthenticatedDokumentasjonAreaRoute,AuthenticatedInvoicesIdRoute: AuthenticatedInvoicesIdRoute,AuthenticatedInvoicesArkivRoute: AuthenticatedInvoicesArkivRoute,AuthenticatedInvoicesSetupRoute: AuthenticatedInvoicesSetupRoute,AuthenticatedQuotesIdRoute: AuthenticatedQuotesIdRoute,AuthenticatedReportsMarginRoute: AuthenticatedReportsMarginRoute,AuthenticatedTakstIdRoute: AuthenticatedTakstIdRoute,AuthenticatedInvoicesIndexRoute: AuthenticatedInvoicesIndexRoute,AuthenticatedQuotesIndexRoute: AuthenticatedQuotesIndexRoute,AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,AuthenticatedTakstIndexRoute: AuthenticatedTakstIndexRoute,AuthenticatedInvoicesIdPdfRoute: AuthenticatedInvoicesIdPdfRoute,AuthenticatedInvoicesIdPurringRoute: AuthenticatedInvoicesIdPurringRoute,AuthenticatedQuotesIdPdfRoute: AuthenticatedQuotesIdPdfRoute,AuthenticatedSettingsImportEntityRoute: AuthenticatedSettingsImportEntityRoute,AuthenticatedSettingsImportIndexRoute: AuthenticatedSettingsImportIndexRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const AuthRouteChildren = {
  AuthCallbackRoute: AuthCallbackRoute
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)




const FeltRouteChildren = {
  FeltFotoRoute: FeltFotoRoute,FeltKursRoute: FeltKursRoute,FeltVeggRoute: FeltVeggRoute,FeltIndexRoute: FeltIndexRoute
}

const FeltRouteWithChildren = FeltRoute._addFileChildren(FeltRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,SplatRoute: SplatRoute,AuthRoute: AuthRouteWithChildren,FeltRoute: FeltRouteWithChildren,OnboardingRoute: OnboardingRoute,ResetPasswordRoute: ResetPasswordRoute,UnsubscribeRoute: UnsubscribeRoute,QTokenRoute: QTokenRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)